import React from "react"
import LibrarySlider from "../components/LibrarySlider"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faAward,
	faUserTie,
	faGlobeAmericas,
	faCalendar,
} from "@fortawesome/free-solid-svg-icons"
import {
	faFacebookF,
	faInstagram,
	faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons"

const Home = () => {
	return (
		<main className="home-page">
			{/* Slider Section */}
			<section>
				<LibrarySlider />
			</section>

			<section className="intro-section">
				<div className="intro-content">
					<div className="intro-text">
						<h2>Your Gateway to Extraordinary Journeys</h2>
						<p>
							Shifting Sands EXP embodies the fluid nature of truly
							transformative travel — where each expedition unveils new
							experiences, and every experience shapes the course of your
							personal odyssey.
						</p>
						<p className="">
							Our name, Shifting Sands EXP, reflects the fluid and
							transformative nature of travel. Just as the Sahara’s shifting
							dunes conceal millennia of secrets, our journeys unveil the
							extraordinary across every corner of the globe. Whether navigating
							the serene Okavango Riverbanks, traversing Algeria's vast deserts,
							or cruising across the open waters from the Arctic to Antarctica,
							we craft experiences that inspire and transform.
						</p>
						<p>
							Come join us in uncovering the extraordinary, where every journey
							whispers tales of adventure and discovery.
						</p>
					</div>
					<div className="intro-image">
						<img
							src="/image/Saudi-Arabia-Al-Ula.jpg"
							alt="Stunning Desert Landscape"
						/>
					</div>
				</div>
			</section>
			{/* Images Section */}
			<div className="image-feature-container">
				<div className="image-section">
					<div className="image-wrapper left-img">
						<img
							src="/image/Old-QUARK-EXPEDITIONS-Sam-Edmonds-Humpback-whale-and-zodiac-copy.jpg"
							alt="QUARK-EXPEDITIONS-Sam-Edmonds-Humpback-whale-and-zodiac"
						/>
						<div className="photo-credit-2">Picture by Quark Expeditions</div>
					</div>
					<div className="image-wrapper middle-img">
						<img
							src="/image/WILDERNESS-Busanga-Bush-Camp-Zambia.jpg"
							alt="Elephant"
						/>
						<div className="photo-credit-2">Picture by Busanga Bush</div>
					</div>
					<div className="image-wrapper">
						<img
							src="/image/WILDERNESS-Davidsons-Standard-Tent.jpg"
							alt="Desert"
						/>
						<div className="photo-credit-2">Picture by Davidsons</div>
					</div>
				</div>
				<div className="feature-section">
					<div className="feature">
						{/* Replaced <i> with FontAwesomeIcon */}
						<FontAwesomeIcon icon={faAward} className="feature-icon" />
						<h3>Unparalleled Expertise</h3>
						<p>
							With decades of experience exploring five continents since 1983, I
							bring a wealth of firsthand knowledge to your journey.
						</p>
					</div>
					<div className="feature">
						<FontAwesomeIcon icon={faUserTie} className="feature-icon" />
						<h3>Personal Concierge</h3>
						<p>
							From initial planning to final details, I handle every aspect of
							your trip, ensuring a seamless, stress-free experience.
						</p>
					</div>
					<div className="feature">
						<FontAwesomeIcon icon={faGlobeAmericas} className="feature-icon" />
						<h3>Individualized Adventures</h3>
						<p>
							Meticulously crafted itineraries to suit your style. From private
							access to immersive cultural encounters, every detail perfected.
							{/* Each itinerary is meticulously crafted to reflect your unique
							style and preferences. From private access to exclusive locales to
							immersive cultural encounters, no detail is overlooked. */}
						</p>
					</div>
				</div>
			</div>
			{/* Big Background Section */}
			<section className="luxury-bg-section">
				<div className="bg-overlay">
					<h2>LUXURY TRAVEL DESIGNER</h2>
					<p>
						Hello, I’m Alex. Welcome to Shifting Sands EXP, where thrilling
						adventures merge seamlessly with luxurious comfort, turning every
						trip into a work of art. As an independent affiliate of Renshaw
						Travel and a proud member of the exclusive Virtuoso Travel Network,
						I’m here to transform your travel dreams into unforgettable
						experiences.
					</p>
				</div>
			</section>
			{/* Final CTA */}
			<section className="final-cta-section">
				<h2>Ready to Start Your Journey?</h2>
				<div className="contact-buttons">
					<button
						onClick={() =>
							(window.location.href = "mailto:alex@shiftingsandsexp.com")
						}
					>
						Connect via Email
					</button>
					<button
						onClick={() =>
							window.open(
								"https://calendly.com/alex-shiftingsandsexp",
								"_blank",
								"noopener,noreferrer"
							)
						}
					>
						Schedule a Call
					</button>
					<button
						onClick={() =>
							window.open(
								"https://docs.google.com/forms/d/e/1FAIpQLScnB4MLFJ93U19RR99l0p8Jxe3xIbovYref42nFSMGIoryTMw/viewform?vc=0&c=0&w=1&flr=0",
								"_blank",
								"noopener,noreferrer"
							)
						}
					>
						Tell Us More
					</button>
				</div>
				<div className="social-row">
					<a
						target="_blank"
						href="https://www.facebook.com/profile.php?id=61564944561810"
						aria-label="Facebook"
					>
						<FontAwesomeIcon icon={faFacebookF} />
					</a>
					<a
						target="_blank"
						href="https://www.instagram.com/shiftingsandsexp/"
						aria-label="Instagram"
					>
						<FontAwesomeIcon icon={faInstagram} />
					</a>
					<a
						target="_blank"
						href="https://www.linkedin.com/company/shifting-sands-exp/"
						aria-label="LinkedIn"
					>
						<FontAwesomeIcon icon={faLinkedinIn} />
					</a>
				</div>
			</section>
		</main>
	)
}

export default Home
